import React from "react";

export default function FamilyTree({ genealogia }) {

  return (
    <div className="family-tree">
      {genealogia && genealogia.map((item, i) => 
        <div key={item.key} className="family-tree-container" style={{ gridArea: item.key }}>
          <div className="content">
            <div className="header">
              <h3>{item.title}</h3>
            </div>
            <div className={`family-tree-body ${item.bgColor}`}>
              <div className="content-container">
                <p>{item.serie} / {item.rgn} / {item.rgd}</p>
              </div>

              <div className="content-container">
                <p>
                  {item.nome}
                </p>
              </div>
              <div className="content-container">
                <p>{item.valor}</p>
                <p>{item.top}</p>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
